import React from 'react';
import { IonButton, IonSpinner } from '@ionic/react';

// Debajo de una lista del admin: cuántos se ven de cuántos hay, y "Cargar más".
const AdminListFooter: React.FC<{ shown: number; total: number; loadingMore: boolean; onMore: () => void }> = ({
  shown,
  total,
  loadingMore,
  onMore,
}) => {
  if (total === 0) return null;
  return (
    <div className="admin-list-footer">
      <span>
        Mostrando {shown.toLocaleString('es-AR')} de {total.toLocaleString('es-AR')}
      </span>
      {shown < total && (
        <IonButton fill="outline" size="small" disabled={loadingMore} onClick={onMore}>
          {loadingMore ? <IonSpinner name="dots" /> : 'Cargar más'}
        </IonButton>
      )}
    </div>
  );
};

export default AdminListFooter;
